import { BaseCell } from '@adc/datatable'

const { COLORED_CELL_OPTIONS } = BaseCell

const colorMap = {
  PENDING: COLORED_CELL_OPTIONS.DEFAULT,
  ACCEPTED: COLORED_CELL_OPTIONS.SUCCESS,
  REVOKED: COLORED_CELL_OPTIONS.INFO,
  DECLINED: COLORED_CELL_OPTIONS.ERROR,
  EXPIRED: COLORED_CELL_OPTIONS.INACTIVE,
}

export const statusColorMapper = value => {
  if (Object.prototype.hasOwnProperty.call(colorMap, value)) {
    return colorMap[value]
  }
  return COLORED_CELL_OPTIONS.DEFAULT
}
